import React from "react";
import { connect } from "react-redux";
import { CorperatePendingApprovedContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import momentTZ from "moment-timezone";
import queryString from "query-string";
import * as XLSX from "xlsx";
import { RENDER_STATUS_PRODUCT_WARRANTY_SET } from "utils/functions/productWarrantySet";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";
import { Displays, Inputs, Tables } from "components";

// แสดงเฉพาะ Set สถานะ Pending Approve (3) ค้นหาด้วยชื่อองค์กร/เบอร์โทรขององค์กร
const PENDING_QUERY = "status=3";

class CorperatePendingApprovedContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_CORPERATE_PRODUCT_SET_LIST(
      `${stringQuery || "?"}&${PENDING_QUERY}`
    );
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({ filterQuery: e });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({ isLoading: true });
    this.props.router.navigate(
      `${ROUTE_PATH.CORPERATE_PENDING_APPROVED}${joinQuery}`
    );
    this.fetchData(joinQuery);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({ isBgLoading: true });
    let res = await portalService.GET_CORPERATE_PRODUCT_SET_LIST(
      `${filterQuery || "?"}&pagination=false&${PENDING_QUERY}`
    );
    this.setState({ isBgLoading: false });
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet([
        ["No", "Create Date", "Sent Date", "Organization", "Setname", "Setcode", "Items"],
        ...res.data.docs.map((e, i) => [
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
          e.sent_at
            ? momentTZ(e.sent_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")
            : "",
          e.organization_name,
          e.name,
          e.code,
          (e.product_warranty_list || []).length,
        ]),
      ]);
      ws["!cols"] = [
        { wch: 5 },
        { wch: 18 },
        { wch: 18 },
        { wch: 30 },
        { wch: 30 },
        { wch: 22 },
        { wch: 8 },
      ];
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.writeFile(
        wb,
        `corperate-pending-approve-${momentTZ()
          .tz("Asia/Bangkok")
          .format("DD-MM-YYYY")}.xlsx`
      );
    } else {
      toast.error("Export ไม่สำเร็จ");
    }
  };

  handleClickDetail = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.CORPERATE_PENDING_APPROVED}/${e}`);
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "corperate");
    return (
      <CorperatePendingApprovedContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? this.handleExport
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <div className="body_table">
            <Tables.Standard
              columns={columns({ handleClickDetail: this.handleClickDetail })}
              data={data}
              showPagination
              pagination={pagination}
              handlePageClick={this.handlePageClick}
              onChangePerPage={this.handlePerPageChange}
            />
          </div>
        )}
      </CorperatePendingApprovedContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "organization_name",
      length: "311px",
      filter: {
        fieldQuery: "organization_name",
        defaultValue: initialValues["organization_name"],
        type: "text",
        label: "ค้นหาชื่อองค์กร",
        placeholder: "ชื่อองค์กร",
      },
    },
    {
      accessor: "phone_number",
      length: "311px",
      filter: {
        fieldQuery: "phone_number",
        defaultValue: initialValues["phone_number"],
        type: "text",
        label: "เบอร์โทร",
        placeholder: "ค้นหาเบอร์โทร",
      },
    },
  ];
};

const columns = ({ handleClickDetail }) => {
  const renderCell = (props, children) => (
    <div
      className="row_click"
      onClick={() => handleClickDetail(props.row.original._id)}
    >
      {children}
    </div>
  );
  return [
    {
      Header: <div style={{ textAlign: "left" }}>Create Date</div>,
      accessor: "created_at",
      Cell: (props) =>
        renderCell(
          props,
          momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")
        ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Organization</div>,
      accessor: "organization_name",
      Cell: (props) => renderCell(props, props.value),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Setname</div>,
      accessor: "name",
      Cell: (props) => renderCell(props, props.value),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Setcode</div>,
      accessor: "code",
      Cell: (props) => renderCell(props, props.value),
    },
    {
      Header: <div style={{ textAlign: "center" }}>Status</div>,
      accessor: "status",
      Cell: (props) => {
        const renderStatus = RENDER_STATUS_PRODUCT_WARRANTY_SET(props.value);
        return renderCell(
          props,
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Displays.StatusLabel
              bg={renderStatus?.bg}
              label={renderStatus?.label}
            />
          </div>
        );
      },
    },
  ];
};

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CorperatePendingApprovedContainer));
